import React from 'react';
import DateField from 'Components/ComponentLibrary/Components/Uncategorized/DateField';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import moment from 'moment';
import PropTypes from 'prop-types';
import { monthYear } from 'Consts/DateFormats';

const DateOrMonthForGroupedInputPicker = ({
  value, onChange, label, disabled, startDate, helperText, title, test, testName,
}) => {
  const momentStartDate = moment(startDate).startOf('month');
  const onMonthChange = (val) => {
    const dateMoment = moment(startDate).add(val, 'months');
    const onChangeValue = dateMoment?.isValid()
      ? dateMoment.toISOString()
      : null;
    return onChange(onChangeValue);
  };

  const finalDate = moment(value).startOf('month');
  let months = finalDate ? finalDate.diff(momentStartDate, 'months') : undefined;

  // set to undefined so you can backspace and not auto-filled with 0
  if (months === 0) {
    months = undefined;
  }

  return (
    <React.Fragment>
      <DateField
        label={label}
        title={title}
        value={value}
        onChange={onChange}
        openTo={'year'}
        views={['year', 'month']}
        format={monthYear}
        disabled={disabled}
        placeholder={monthYear}
        helperText={helperText}
        minDate={momentStartDate.format()}
        test={test}
        testName={testName}
      />
      <TextField
        onChange={onMonthChange}
        type={'number'}
        value={months}
        disabled={disabled}
        label={'Months'}
        focused={!disabled && value}
        test={`${test}-month-difference-input`}
      />
    </React.Fragment>
  );
};

DateOrMonthForGroupedInputPicker.defaultProps = {
  value: undefined,
  label: undefined,
  disabled: false,
  startDate: moment().toISOString(),
  helperText: undefined,
  title: undefined,
  test: undefined,
  testName: undefined,
};

DateOrMonthForGroupedInputPicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  startDate: PropTypes.string,
  helperText: PropTypes.string,
  title: PropTypes.string,
  test: PropTypes.string,
  testName: PropTypes.string,
};

export default DateOrMonthForGroupedInputPicker;
